import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { ActivityLog } from './../models/activitylog';
import { ActivityLogServices } from './activitylog.services';

@Injectable()
export class ActivityLogListResolver {

    constructor(private backend: ActivityLogServices) { }

    resolve(route: ActivatedRouteSnapshot): Observable<ActivityLog[]> {
        return this.backend.getAllActivityLog();
    }

}